// JsFromRoutes CacheKey 671e55fcc5c15160c07a9a93951f67fc
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  activate: /* #__PURE__ */ definePathHelper('get', '/members/cards/:card_id/activate'),
  activated: /* #__PURE__ */ definePathHelper('get', '/members/cards/:card_id/activated'),
  cancel: /* #__PURE__ */ definePathHelper('post', '/members/cards/:card_id/cancel'),
  changePin: /* #__PURE__ */ definePathHelper('get', '/members/cards/:card_id/change_pin'),
  createPhysicalCard: /* #__PURE__ */ definePathHelper('post', '/members/cards/create_physical_card'),
  createVirtualCard: /* #__PURE__ */ definePathHelper('post', '/members/cards/create_virtual_card'),
  freeze: /* #__PURE__ */ definePathHelper('post', '/members/cards/:card_id/freeze'),
  newPhysicalCard: /* #__PURE__ */ definePathHelper('get', '/members/cards/new_physical_card'),
  replace: /* #__PURE__ */ definePathHelper('get', '/members/cards/:card_id/replace'),
  replaceSubmit: /* #__PURE__ */ definePathHelper('post', '/members/cards/:card_id/replace_submit'),
  setPin: /* #__PURE__ */ definePathHelper('get', '/members/cards/:card_id/set_pin'),
  updatePin: /* #__PURE__ */ definePathHelper('get', '/members/cards/:card_id/update_pin'),
  unfreeze: /* #__PURE__ */ definePathHelper('post', '/members/cards/:card_id/unfreeze'),
  index: /* #__PURE__ */ definePathHelper('get', '/members/cards'),
  activationRedirect: /* #__PURE__ */ definePathHelper('get', '/members/cards/activate'),
}
